export function sanitizeLocalReturnTo(value: string | null, fallback = "/"): string {
  if (!value) return fallback;
  let decoded = value.trim();
  try {
    for (let index = 0; index <= value.length; index += 1) {
      if (!decoded.startsWith("/") || decoded.startsWith("//") || decoded.includes("\\") || [...decoded].some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) return fallback;
      const next = decodeURIComponent(decoded.replace(/%(?![0-9a-f]{2})/gi, "%25"));
      if (next === decoded) break;
      if (index === value.length) return fallback;
      decoded = next;
    }
    if (/^\/(?:signin|signup|auth)(?:\/|$)/.test(new URL(decoded, window.location.origin).pathname)) return fallback;
    const target = new URL(value.trim(), window.location.origin);
    return target.origin === window.location.origin ? `${target.pathname}${target.search}${target.hash}` : fallback;
  } catch { return fallback; }
}

export const accountsOrigin = import.meta.env.VITE_STORY_ENVIRONMENT === "preview"
  ? "https://login-mcp-preview.xhalo.co" : "https://app.xhalo.co";

export function accountsSignInUrl(locale: string): string {
  const callback = new URL("/auth/callback", import.meta.env.VITE_STORY_ENVIRONMENT === "preview" ? "https://story-preview.xhalo.co" : window.location.origin);
  callback.searchParams.set("returnTo", sanitizeLocalReturnTo(`${window.location.pathname}${window.location.search}${window.location.hash}`));
  const target = new URL("/signin", accountsOrigin);
  target.searchParams.set("locale", locale);
  target.searchParams.set("redirect", callback.toString());
  return target.toString();
}
